import { createFileRoute } from "@tanstack/react-router";
import { ChatPage } from "../features/chat/chat-page";
import { validateChatSearch } from "../features/chat/search";

export const Route = createFileRoute("/_app/w/$workspace/p/$project/chat")({
  validateSearch: validateChatSearch,
  component: ChatPage,
});
